export enum MediaRoleEnum {
  Main = 'main',
  Background = 'background',
  Screen = 'screen',
  Speaker1 = 'speaker1',
  Speaker2 = 'speaker2',
  Speaker3 = 'speaker3',
  Speaker4 = 'speaker4',
  Broll = 'broll',
  Logo = 'logo',
  Overlay = 'overlay',
  TitleSlide = 'titleSlide',
  QuoteSlide = 'quoteSlide',
  CallToAction = 'callToAction',
  TitleParagraph = 'titleParagraph',
  TitleList = 'titleList',
  BigFact = 'bigFact',
  Captions = 'captions',
  Chapter = 'chapter'
}

export type MediaRole = `${MediaRoleEnum}`;

export const MEDIA_ROLES = Object.values(MediaRoleEnum) as [MediaRole, ...MediaRole[]];

const MEDIA_ROLE_SET: ReadonlySet<MediaRole> = new Set(MEDIA_ROLES);

export function isMediaRole(value: unknown): value is MediaRole {
  return typeof value === 'string' && MEDIA_ROLE_SET.has(value as MediaRole);
}

export function normalizeMediaRole(value: unknown, fallback: MediaRole = MediaRoleEnum.Main): MediaRole {
  return isMediaRole(value) ? value : fallback;
}
